import * as sup from "superstruct";

import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";
import { createResponseStruct } from "@/modules/api/utils/jsonApiStructs";
import { attachmentWithUrlResourceStruct } from "@/modules/attachment/attachmentResourceStruct";
import { handbookResourceStruct } from "@/modules/handbooks/api/resources/handbook/handbookResourceStruct";
import { takenTestQuestionSingleResourceStruct } from "@/modules/tutorialTest/resources/takenTestQuestionSingle/takenTestQuestionSingleResourceStruct";

import { getTutorialProgressPath } from "../../resources/tutorialProgress/tutorialProgressResourceConsts";
import { tutorialProgressResourceStruct } from "../../resources/tutorialProgress/tutorialProgressResourceStruct";
import { tutorialStepResourceStruct } from "../../resources/tutorialStep/tutorialStepResourceStruct";

export const getTutorialProgressQuery = (
  jsonApi: JsonApiClient,
  { companyId, tutorialId }: { companyId: string; tutorialId: string }
) => {
  return jsonApi.getOne({
    path: getTutorialProgressPath(companyId, tutorialId),
    responseStruct: getTutorialProgressResponseStruct,
  });
};

const getTutorialProgressResponseStruct = createResponseStruct({
  data: tutorialProgressResourceStruct,
  included: sup.array(
    sup.union([
      tutorialStepResourceStruct,
      takenTestQuestionSingleResourceStruct,
      attachmentWithUrlResourceStruct,
      handbookResourceStruct,
    ])
  ),
});

export type GetTutorialProgressResponseStruct = sup.Infer<
  typeof getTutorialProgressResponseStruct
>;
